import React, { Component, Fragment } from 'react';
import './index.scss';
import Head from "../../../../../layout/Head/Head";

export default class JobDetails extends Component {

  componentDidMount() {
    window.Grnhse.Iframe.load(this.props.match.params.id);
  }

  render() {
    return (
      <Fragment>
        <Head title="Connatix - Job Description" />
        <div id="grnhse_app" />
      </Fragment>
    );
  }
}